export * from "./SelecaoMarca";
